<template>
  <div style="margin-left: 20">
    <div class="container">
      <div class="row">
        <table>
          <tr>
            <td>
              <h2
                style="margin-top: 10px; margin-left: 15px; margin-bottom: 10px"
              >
                Mumbai Task Level Feedback Form
              </h2>
            </td>
          </tr>
        </table>
      </div>
    </div>
    <form id="form_id" @submit.prevent="processForm">
      <div class="container">
        <table class="table-horizontal" width="50%" height="20">
          <tbody>
            <tr>
              <td><strong>Date</strong></td>
              <td>
                <input
                  class="us"
                  type="text"
                  v-model="feeddate"
                  readonly="true"
                  required
                  style="width: 273px"
                />
              </td>
            </tr>
            <tr>
              <td><strong>Group Name</strong></td>
              <td>
                <input
                  class="us"
                  type="text"
                  v-model="group"
                  readonly="true"
                  required
                  style="width: 273px"
                />
              </td>
            </tr>
            <tr>
              <td><strong>Deal/Company Name</strong></td>
              <td>
                <input
                  class="us"
                  type="text"
                  size="29"
                  readonly="true"
                  v-model="companyname"
                  required
                />
              </td>
            </tr>
            <tr>
              <td><strong>Function Supported</strong></td>
              <td>
                <input
                  class="us"
                  type="text"
                  size="29"
                  readonly="true"
                  v-model="functionSupported"
                  required
                />
              </td>
            </tr>
            <tr>
              <td><strong>Tasks Performed</strong></td>
              <td>
                <div id="divTaskPerformed">
                  <td>
                    <input
                      class="us"
                      type="text"
                      readonly="true"
                      v-model="task_performed"
                      size="29"
                      required
                    />
                  </td>
                </div>
              </td>
            </tr>
            <tr>
              <td><strong>Primary Analyst Email ID</strong></td>
              <td>
                <input
                  class="us"
                  type="text"
                  readonly="true"
                  v-model="usanalystid"
                  size="29"
                  required
                />
              </td>
            </tr>
            <tr>
              <td><strong>Mumbai Analyst Email ID</strong></td>
              <td>
                <input
                  class="us"
                  type="text"
                  readonly="true"
                  v-model="mumbaianalystid"
                  size="29"
                  required
                />
              </td>
            </tr>
            <tr v-if="group === 'EMEA RMBS/ABS'" id="Par_Due_Date">
              <td><strong>Par Due Date</strong></td>
              <td>
                <input
                  class="us"
                  type="text"
                  readonly="true"
                  v-model="Par_due_date"
                  style="width: 273px"
                />
              </td>
            </tr>
            <tr id="Comment">
              <td><strong>Comment</strong></td>
              <td>
                <textarea
                  class="us"
                  v-model="comment"
                  name="comment"
                  readonly
                ></textarea>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
      <div class="container">
        <div class="row">
          <div class="col-md-8">
            <label
              ><b
                ><u><h4>Evaluation Criteria:</h4></u></b
              ></label
            >
            <table
              id="evaluationCriteria"
              style="
                border-collapse: collapse;
                border: 1px solid black;
                border: solid;
                border-width: 1px;
              "
            >
              <tbody style="display: inline-grid">
                <tr
                  style="display: inline-table"
                  v-for="item in questAnswMapkey"
                  v-bind:key="item.id"
                  v-bind:id="item"
                >
                  <td
                    v-if="item != 'Any other comments'"
                    style="border: 1px solid black; padding: 15px; width: 50%"
                  >
                    {{ item }}
                  </td>
                  <td
                    v-if="item != 'Any other comments'"
                    style="border: 1px solid black; width: 50%"
                    align="center"
                  >
                    <span v-if="CRSFeedbackQuesAns">{{
                      CRSFeedbackQuesAns[item].toString()
                    }}</span>
                    <!-- alert({{CRSFeedbackQuesAns[item].length}}) -->
                    <select
                      style="width: 180px"
                      v-model="usans[item]"
                      v-bind:id="item"
                      v-if="item != 'Any other comments' && !CRSFeedbackQuesAns"
                      :ref="item"
                      @change="CalculateFeedback"
                    >
                      <option
                        v-for="quesAns in questAnswMap[item]"
                        v-bind:key="quesAns.id"
                        v-bind:id="quesAns"
                      >
                        {{ quesAns }}
                      </option>
                    </select>
                  </td>
                </tr>
                <tr>
                  <div class="container">
                    <div class="grid-row">
                      <td style="margin-top: 22px">Comment</td>
                      <td style="width: 500px; margin-left: 30px">
                        <div class="grid-row" style="padding-top: 10px">
                          <textarea
                            id="usComment"
                            style="width: 600px"
                            v-model="usComment"
                            @change="getData"
                          >
                          </textarea>

                          <span v-show="Commentrequirement" style="color: red"
                            >Comment is required</span
                          >
                        </div>
                        <div id="commentdiv">
                          <div id="tooltip1" class="tooltip1">
                            <textarea
                              id="usComment"
                              style="width: 100%; height: 100%"
                              v-model="usComment"
                            >
                            </textarea>
                            <button
                              :disabled="isnotActive"
                              type="button"
                              v-on:click="closeComment"
                            >
                              Close
                            </button>
                          </div>
                        </div>
                        <span
                          v-if="!CRSFeedbackQuesAns"
                          v-on:click="expandComment"
                          style="width: 500px; margin-left: 100px; color: blue"
                          ><u>click here to expand comment box</u></span
                        >
                      </td>
                    </div>
                  </div>
                </tr>
                <tr style="border: 1px solid black">
                  <div class="container">
                    <div class="row">
                      <td style="padding-left: 15px">Attach file</td>
                      <td style="padding-left: 120px">
                        <input
                          type="file"
                          id="files"
                          ref="files"
                          multiple
                          v-on:change="handleFilesUpload"
                        />
                        <div class="large-12 medium-12 small-12 cell">
                          <div
                            v-for="(file, key) in files"
                            class="file-listing"
                            v-bind:key="key.id"
                            v-bind:id="key"
                          >
                            {{ file.name }}
                            <span
                              class="remove-file"
                              v-on:click="removeFile(key)"
                              >Remove</span
                            >
                          </div>
                        </div>
                        <div class="large-12 medium-12 small-12 cell">
                          <button
                            :disabled="isnotActive"
                            v-on:click="addFiles()"
                          >
                            Add Files
                          </button>
                        </div>
                      </td>
                    </div>
                  </div>
                </tr>

                <tr>
                  <div class="container">
                    <div class="row">
                      <td style="padding-left: 15px; width: 30%">
                        <strong>Overall Quality</strong>
                      </td>
                      <td style="padding-left: 18px; width: 70%">
                        <input
                          type="text"
                          v-model="feed"
                          name="feed"
                          readonly
                          placeholder="feedback"
                        />
                      </td>
                    </div>
                  </div>
                </tr>
                <tr>
                  <td>
                    <button
                      style="width: 100px; margin-left: 205px"
                      type="submit"
                      :disabled="isnotActive"
                      v-on:click="submitForm"
                    >
                      Submit
                    </button>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
          <div class="col-md-4" style="margin-top: 44px">
            <table
              style="
                border-collapse: collapse;
                border: 1px solid black;
                width: 100%;
                border: solid;
                border-width: 1px;
              "
            >
              <tbody>
                <tr
                  style="
                    border-collapse: collapse;
                    border: 1px solid black;
                    width: 100%;
                    border: solid;
                    border-width: 1px;
                  "
                  v-for="(value, name) in CRSvaluatioCriteria"
                  v-bind:key="name.id"
                  v-bind:id="name"
                >
                  <td style="border: 1px solid black">
                    {{ name }}
                  </td>
                  <td style="border: 1px solid black">
                    {{ value }}
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
      <!-- CRS ENDS HERE -->
    </form>
  </div>
</template>

<script>
import axios from "axios";
const S3_DIRECTORY = "CRS-us-feedback-files/";
export default {
  name: "us",
  props: {},
  data() {
    return {
      files: [],
      isnotActive: false,
      Commentrequirement: false,
      horizontal: "",
      message: false,
      CRS: false,
      feed: "",
      usans: {},
      usComment: "",
      jsonresponse: {},
      feeddate: "",
      companyname: "",
      functionSupported: "",
      group: "",
      task_performed: "",
      usanalystid: "",
      mumbaianalystid: "",
      Par_due_date: "",
      comment: "",
      modelId: "",
      questAnswMap: [],
      questAnswMapkey: [],
      ans: [],
      rowCount: "",
      quesAns: "",
      Timeliness: "Met",
      orderDecider: 0,
      CRSvaluatioCriteria: {},
      CRSvaluatioCriteriaKeys: [],
      CRSFeedbackQuesAns: {},
      CRSFeedbackQuesAnsKeys: [],
    };
  },
  async created() {
    const getUrl = new URL(
      process.env.VUE_APP_BACKEND_API + "CRS/usfeedbackform",
    );
    getUrl.searchParams.append("feeddate", this.getParameterByName("feeddate"));
    getUrl.searchParams.append("grpname", this.getParameterByName("grpname"));
    getUrl.searchParams.append(
      "companyname",
      this.getParameterByName("companyname"),
    );
    getUrl.searchParams.append(
      "functionsupported",
      this.getParameterByName("functionsupported"),
    );
    getUrl.searchParams.append(
      "tasksperformed",
      this.getParameterByName("tasksperformed"),
    );
    getUrl.searchParams.append(
      "usanalystid",
      this.getParameterByName("usanalystid"),
    );
    getUrl.searchParams.append(
      "mumbaianalystid",
      this.getParameterByName("mumbaianalystid"),
    );
    getUrl.searchParams.append("comment", this.getParameterByName("comment"));

    const response = await axios
      .get(getUrl)
      .then((response) => (this.jsonresponse = response))
      .catch((error) => {
        this.errorMessage = error.message;
        console.error("There was an error!", error);
      });
    this.jsonresponse = response.data;
    console.log("data from mumbai=" + JSON.stringify(this.jsonresponse));
    this.feeddate = this.jsonresponse.usfeedbackformmap.feeddate;
    this.companyname = this.jsonresponse.usfeedbackformmap.companyname;
    this.functionSupported =
      this.jsonresponse.usfeedbackformmap.functionsupported;
    this.group = this.jsonresponse.usfeedbackformmap.grpname;
    this.CRSvaluatioCriteria = this.jsonresponse.criteria;
    this.CRSvaluatioCriteriaKeys = Object.keys(this.CRSvaluatioCriteria);
    this.CRSFeedbackQuesAns = this.jsonresponse.feedbackQuesAnsMap;
    if (this.CRSFeedbackQuesAns) {
      this.CRSFeedbackQuesAnsKeys = Object.keys(this.CRSFeedbackQuesAns);
      this.feed = this.CRSFeedbackQuesAns["OVERALL FEEDBACK"];
      this.usComment = this.CRSFeedbackQuesAns["Any other comments"];
      this.isnotActive = true;
      document.getElementById("usComment").readOnly = true;
      document.getElementById("evaluationCriteria").classList.add("grayout");
    }

    // alert(JSON.stringify(this.CRSvaluatioCriteriaKeys))
    if (this.group === "CRS") {
      this.CRS = 1;
    } else {
      this.CRS = 0;
    }
    this.task_performed = this.jsonresponse.usfeedbackformmap.tasksperformed;
    this.usanalystid = this.jsonresponse.usfeedbackformmap.usanalystid;
    this.mumbaianalystid = this.jsonresponse.usfeedbackformmap.mumbaianalystid;
    this.modelId = this.jsonresponse.modelId;
    this.Par_due_date = this.$route.query.Par_due_date;
    this.comment = this.jsonresponse.usfeedbackformmap.comment;
    this.rowCount = this.jsonresponse.usfeedbackformmap.rowCount;
    this.questAnswMap = this.jsonresponse.questAnswMap;
    this.questAnswMapkey = Object.keys(this.jsonresponse.questAnswMap);

    this.ans = Object.values(this.jsonresponse.questAnswMap);

    console.log(this.rowCount);
  },
  methods: {
    buildS3FileName(fileName) {
      const safeName = String(fileName || "attachment");
      const ext = (safeName.match(/\.[^./]+$/) || [""])[0];
      const base =
        safeName.slice(0, safeName.length - ext.length) || "attachment";
      return `${Date.now()}-${Math.random().toString(36).slice(2, 10)}__${encodeURIComponent(base)}${ext}`;
    },
    getParameterByName(name, url = window.location.href) {
      name = name.replace(/[/[\]]/g, "\\$&");
      var regex = new RegExp("[?&]" + name + "(=([^&#]*)|&|#|$)"),
        results = regex.exec(url);
      if (!results) return null;
      if (!results[2]) return "";
      return decodeURIComponent(results[2].replace(/\+/g, " "));
    },
    handleFilesUpload() {
      let uploadedFiles = this.$refs.files.files;
      for (var i = 0; i < uploadedFiles.length; i++) {
        let fileObj = {};
        fileObj.name = uploadedFiles[i].name;
        fileObj.s3Name = this.buildS3FileName(uploadedFiles[i].name);
        fileObj.fileinstance = uploadedFiles[i];
        this.files.push(fileObj);
      }
      this.$refs.files.value = "";
    },
    addFiles() {
      this.$refs.files.click();
    },
    removeFile(key) {
      this.files.splice(key, 1);
    },
    validateForm() {
      if (this.usComment.length < 1) {
        if (this.feed.length === 0) {
          this.Commentrequirement = true;
          return false;
        }

        this.Commentrequirement = false;
        return true;
      } else {
        this.Commentrequirement = false;
        if (!this.feed) {
          return false;
        }

        return true;
      }
    },
    handleFileUpload() {
      this.file = this.$refs.file.files[0];
    },
    expandComment() {
      document.getElementById("tooltip1").style.transition =
        "opacity 0.5s ease";
      document.getElementById("tooltip1").style.visibility = "visible";
      document.getElementById("tooltip1").style.opacity = "1";
    },
    closeComment() {
      document.getElementById("tooltip1").style.transition =
        "opacity 0.5s ease";
      document.getElementById("tooltip1").style.visibility = "hidden";
      document.getElementById("tooltip1").style.opacity = "0";
    },
    getData() {
      Object.assign(this.usans, { "Any other comments": this.usComment });
    },
    async getPresignedURL(fileName, contentType) {
      const url =
        process.env.VUE_APP_RCA_LAMBDA +
        "presigned_url?" +
        new URLSearchParams({
          fileName: S3_DIRECTORY + fileName,
          fileType: contentType || "application/octet-stream",
        });
      const s3PresignedURL = fetch(url, {
        method: "get",
        credentials: "include",
      })
        .then((res) => {
          if (res.ok) {
            return res.json();
          } else {
            throw new Error("failed to get Presigned URL");
          }
        })
        .catch((err) => console.error(`${err.message}`));
      return s3PresignedURL;
    },
    upload(s3UploadURL = "", file, file_type) {
      // using fetch here because AWS requires to set correct content-type
      const resolvedType = file_type || "application/octet-stream";
      const res = fetch(s3UploadURL, {
        method: "PUT",
        headers: { "Content-Type": resolvedType },
        body: file,
      })
        .then((res) => {
          if (res.ok) {
            //console.log(`files uploaded to S3 sucessfully`)
            return res;
          } else {
            throw new Error("failed to upload file to S3 bucket");
          }
        })
        .catch((err) => {
          console.error(`${err.message}`);
          alert(err.message);
          throw new Error(err.message);
        });
      return res;
    },
    async UploadfilesToS3(files) {
      for (let i = 0; i < files.length; i++) {
        let file = files[i];
        const respdata = await this.getPresignedURL(
          file.s3Name,
          file.fileinstance.type,
        );
        const newFile_name = file.name;
        const newFile = new File([file.fileinstance], newFile_name, {
          type: file.fileinstance.type,
        });
        await this.upload(respdata, newFile, newFile.type);
      }
      return this.files;
    },
    async submitForm() {
      if (this.validateForm()) {
        let fileNames = [];
        this.isnotActive = true;
        if (this.files && this.files && this.files.length > 0) {
          console.log("init file upload");
          // upload files to s3
          await this.UploadfilesToS3(this.files);
        }

        for (let i = 0; i < this.files.length; i++) {
          let file = this.files[i];
          fileNames.push(file.s3Name);
        }

        const formData = {
          feeddate: this.feeddate,
          grpname: this.group,
          companyname: this.companyname,
          functionsupported: this.functionSupported,
          tasksperformed: this.task_performed,
          usanalystid: this.usanalystid,
          mumbaianalystid: this.mumbaianalystid,
          comment: this.comment,
          usans: this.usans,
          feed: this.feed,
          files: fileNames,
        };

        axios
          .post(
            process.env.VUE_APP_BACKEND_API + "CRS/usfeedbackform",
            formData,
            { headers: { "Content-Type": "application/json" } },
          )
          .then(
            (response) => {
              if (response.status === 200)
                alert("entry stored in database and mail has been sent");
              window.location.href = process.env.VUE_APP_UI;
            },
            (error) => {
              if (error.response.status === 400) {
                alert("Response already recorded");
                this.$router.go();
                this.isnotActive = false;
              } else {
                alert("Some error in recording response");
                this.$router.go();
                this.isnotActive = false;
              }
            },
          );
      }
    },
    CalculateFeedback() {
      var option;
      var DataAccuracyScore;
      var FeedbackIncorporatedScore;
      var AnalyticalinputsScore;

      var calculateFeedback = this.modelId;

      if (
        calculateFeedback == 61 ||
        calculateFeedback == 62 ||
        calculateFeedback == 12
      ) {
        option = 1;
      }

      switch (option) {
        case 1: //crs
          if (this.usans["Data Accuracy"] === "Fully Accurate") {
            DataAccuracyScore = 3;
          } else if (this.usans["Data Accuracy"] === "Fairly Accurate") {
            DataAccuracyScore = 2.5;
          } else DataAccuracyScore = 0;

          if (
            this.usans["Feedback Incorporated"] === "Yes" ||
            this.usans["Feedback Incorporated"] === "No Feedback"
          ) {
            FeedbackIncorporatedScore = 3;
          } else if (
            this.usans["Feedback Incorporated"] === "Partially Incorporated"
          ) {
            FeedbackIncorporatedScore = 1.5;
          } else FeedbackIncorporatedScore = 0;

          if (
            this.usans["Analytical inputs"] === "Highly Satisfied" ||
            this.usans["Analytical inputs"] === "Was Not in Scope"
          ) {
            AnalyticalinputsScore = 3;
          } else if (this.usans["Analytical inputs"] === "Satisfied") {
            AnalyticalinputsScore = 2.5;
          } else AnalyticalinputsScore = 0;

          var DataAccuracyWeight = 0.4;
          var FeedbackIncorporatedWeight = 0;
          var AnalyticalinputsWeight = 0;
          var FeedbackIncorporatedFactor;
          var AnalyticalinputsFactor;
          var DataAccuracyFactor;

          if (this.usans["Data Accuracy"] == "Inaccurate") {
            DataAccuracyWeight = 0;
          } else {
            DataAccuracyWeight = 0.4;
          }

          if (this.usans["Feedback Incorporated"] === "No Feedback") {
            FeedbackIncorporatedWeight = 0;
          } else {
            FeedbackIncorporatedWeight = 0.4;
          }

          if (this.usans["Analytical inputs"] === "Was Not in Scope") {
            AnalyticalinputsWeight = 0;
          } else {
            AnalyticalinputsWeight = 0.1;
          }

          var totalWeight =
            DataAccuracyWeight +
            FeedbackIncorporatedWeight +
            AnalyticalinputsWeight;
          DataAccuracyFactor = DataAccuracyWeight / totalWeight;
          FeedbackIncorporatedFactor = FeedbackIncorporatedWeight / totalWeight;
          AnalyticalinputsFactor = AnalyticalinputsWeight / totalWeight;

          var avgpoints =
            (DataAccuracyScore * DataAccuracyFactor +
              FeedbackIncorporatedScore * FeedbackIncorporatedFactor +
              AnalyticalinputsScore * AnalyticalinputsFactor) /
            (DataAccuracyFactor +
              FeedbackIncorporatedFactor +
              AnalyticalinputsFactor);
          if (avgpoints >= 2.9) this.feed = "Highly Satisfied";
          else if (avgpoints >= 2.1) this.feed = "Satisfied";
          else this.feed = "Not at par";
          break;
      }
      var roundOff = avgpoints.toFixed(2);
      if (roundOff >= 2.5) this.feed = "Highly Satisfied";
      else if (roundOff >= 2) this.feed = "Satisfied";
      else this.feed = "Not at par";
    },
  },
};
</script>

<style scoped>
* {
  font-family:
    "Univers", HelveticaNeue, "Helvetica Neue", Helvetica, Arial, sans-serif;
}

.tooltip1 {
  width: 90%;
  height: 200px;
  visibility: hidden;
  background-color: #fff;
  padding: 20px;
  -webkit-box-shadow: 0 0 50px 0 rgba(0, 0, 0, 0.3);
  opacity: 0;
  transition: opacity 0.5s ease;
  position: absolute;
  top: 50%;
  left: 5%;
  z-index: 1;
}

#commentdiv {
  cursor: pointer;
}

#commentdiv:hover .tooltip1 {
  visibility: visible;
  transition: opacity 0.5s ease;
  opacity: 1;
}

.wrapper {
  display: flex;
  flex-direction: column;
}
.grid-row {
  margin-bottom: 1em;
}
.grid-row,
.grid-header {
  display: flex;
  /*   flex: 1 0 auto; */
  /*   height: auto; */
}

.grid-header {
  align-items: flex-end;
}
.header-item {
  width: 100px;
  text-align: center;
  /*   border:1px solid transparent; */
}
.header-item:nth-child(1) {
  width: 180px;
}
.subtitle {
  font-size: 0.7em;
}
.flex-item:before {
  content: "";
  padding-top: 26%;
}
.flex-item {
  display: flex;
  /*   flex-basis:25%; */
  width: 100px;
  border-bottom: 1px solid #ccc;
  justify-content: center;
  align-items: center;
  /*   text-align:left; */
  font-size: 1em;
  font-weight: normal;
  color: #999;
}
.flex-item:nth-child(1) {
  border: none;
  font-size: 1.15em;
  color: #000;
  width: 180px;
  justify-content: left;
}

.flex-itemtime:before {
  content: "";
  padding-top: 26%;
}
.flex-itemtime {
  /*   flex-basis:25%; */
  border-bottom: 1px solid #ccc;
  justify-content: center;
  align-items: center;
  /*   text-align:left; */
  font-size: 1em;
  font-weight: normal;
  color: #999;
}
.flex-itemtime:nth-child(1) {
  border: none;
  font-size: 1.15em;
  color: #000;
  justify-content: left;
}
/* HTML5 Boilerplate accessible hidden styles */

[type="radio"],
[type="checkbox"] {
  border: 0;
  height: 1px;
  margin: -1px;
  overflow: hidden;
  padding: 0;
  position: absolute;
  width: 1px;
}

/* One radio button per line */
label {
  /*display: block;*/
  cursor: pointer;
}

/* the basic, unchecked style */
[type="radio"] + span:before,
[type="checkbox"] + span:before {
  content: "";
  display: inline-block;
  width: 1.5em;
  height: 1.5em;
  vertical-align: -0.25em;
  border: 0.125em solid #fff;
  box-shadow: 0 0 0 0.15em #555;
  transition: 0.5s ease all;
}
[type="checkbox"] + span:before {
  margin-right: 0.75em;
}

/* the checked style using the :checked pseudo class */
[type="radio"]:checked + span:before,
[type="checkbox"]:checked + span:before {
  background: black;
}

/* never forget focus styling */
[type="radio"]:focus span:after {
  content: "\0020\2190";
  font-size: 1.5em;
  line-height: 1;
  vertical-align: -0.125em;
}
.us {
  width: 273px;
}
input[type="file"] {
  display: none;
}
span.remove-file {
  color: red;
  cursor: pointer;
  float: right;
}
.flex-container {
  display: flex;
  flex-direction: column;
}
.grayout {
  opacity: 0.6; /* Real browsers */
  filter: alpha(opacity = 60); /* MSIE */
}
</style>
